/** Tailwind's `md` and `lg` as media queries, for layout decisions made in JS. */
export const PHONE_QUERY = '(max-width: 767px)';
export const NARROW_QUERY = '(max-width: 1023px)';
